import React from 'react';

import { DocumentSummaryDrawer } from 'src/editor/toolbars/right-panel/document-summary/DocumentSummaryDrawer';

interface DocumentPreviewContentProps {
  documentId: UUID;
}

/**
 * Document preview content for the global drawer.
 * Used when viewing a document preview from the Repository or Party page.
 */
export function DocumentPreviewContent({ documentId }: DocumentPreviewContentProps): JSX.Element {
  return <DocumentSummaryDrawer documentId={documentId} />;
}
